// extracted by mini-css-extract-plugin
export default {"container":"TrainingMaterial_container__j1HNM","title":"TrainingMaterial_title__Yukkz","flexBox":"TrainingMaterial_flexBox__lx4fl","flexItem":"TrainingMaterial_flexItem__uiUYT"};